export default {
  data() {
    return {
      loading: false, // 遮罩
      id: this.$route.query.id, // id
      type: this.$route.query.type, // 操作类型
      form: this.$refs['form'], //
    }
  },
  mounted() {
    if (this.$route.query.type === 'update') {
      // console.log("判断id("+this.$route.query.id+")是不是数组"+this.$route.query.id);
      if (Array.isArray(this.$route.query.id)) {
        this.id = this.$route.query.id[0]
      } else {
        this.id = this.$route.query.id;
      }

    }
  },
  // beforeRouteEnter(to, from, next) {
  //   next(vm => {
  //     vm.$store.dispatch('reFreshViews', true)
  //     let toPath = to.path;
  //     console.log(toPath,'toPath');
  //     let viewRouters = vm.$store.state.tagsView.visitedViews;
  //     let flag = true;
  //     for (let route of viewRouters) {
  //       if (toPath === route.path) {
  //         console.log(to.query,route.oldQuery)
  //         if(vm.compareObject(to.query,route.oldQuery)){
  //           console.log("参数相等");
  //         }else{
  //           console.log("参数不同")
  //           vm.$store.dispatch('reFreshViews', false)
  //           vm.clearKeepAlive();
  //           vm.$nextTick(function (){
  //             vm.$store.dispatch('reFreshViews', true)
  //           })
  //         }
  //         flag = false;
  //       }
  //     }
  //     if(flag){
  //       vm.$store.dispatch('reFreshViews', false)
  //       vm.clearKeepAlive();
  //       vm.$nextTick(function (){
  //         vm.$store.dispatch('reFreshViews', true)
  //       })
  //     }
  //   })
  // },
  methods: {
    compareObject(obj1, obj2) {
      let str1 =JSON.stringify(obj1);
      let str2 = JSON.stringify(obj2);
      if(str1 ===str2){
        return true;
      }else{
        return false;
      }
      // if (obj1 instanceof Object && obj2 instanceof Object) {
      //   let length1 = Object.keys(obj1).length;
      //   let length2 = Object.keys(obj2).length;
      //   if (length1 != length2) {
      //     return false;
      //   }
      //   let flag = true;
      //   for (let i in obj1) {
      //     if (this.compareObject(obj1[i], obj2[i])) {
      //
      //     } else {
      //       flag = false;
      //     }
      //   }
      //   return flag;
      // } else {
      //   if (obj1 === obj2) {
      //     return true;
      //   } else {
      //     return false;
      //   }
      // }
    },
    /**
     * @param {string} url 添加方法的api地址
     * @param {object} params 添加的参数
     * @param {string} backUrl ，返回列表的路由地址
     */
    getDataInfo(id, obj) {
    },
    saveDataInfo(url, params, callback) {
      let form = this.$refs['form']
      form.validate(valid => {
        // 验证方法
        if (valid) {
          this.loading = true
          // $api.busiContentDesigner.addData
          this.$fetchData(url, params, 'post')
            .then(res => {
              this.loading = false
              if (res) {
                console.log(callback)
                if (callback && typeof callback === 'function') {
                  callback(res)
                }
                this.$message.success('添加成功')
                this.$router.go(-1)
              }
            })
            .catch(error => {
              this.loading = false
            })
        } else {
          return false
        }
      })
    },
    updateDataInfo(url, params, backUrl) {
      let form = this.$refs['form']
      form.validate(valid => {
        // 验证方法
        if (valid) {
          this.loading = true
          this.$fetchData(url, params, 'post')
            .then(res => {
              this.loading = false
              if (res) {
                this.$message.success('修改成功')
                this.$router.go(-1)
              }
            })
            .catch(error => {
              this.loading = false
            })
        } else {
          return false
        }
      })
    },
    /**
     *
     * @param {string} type 判断添加还是修改 save，update
     */
    isType(type) {
      return this.type === type ? true : false
    },
    reset() {
      this.getDataInfo(this.id);
    },
    //关闭当前tag页
    closeTag() {
      this.clearKeepAlive();
      let view = {"name": this.$route.name, "path": this.$route.path};
      this.$store.dispatch('delVisitedViews', view).then((views) => {
      })
    },
    //清空keepAlive缓存
    clearKeepAlive() {
      if (this.$vnode && this.$vnode.data.keepAlive) {
        if (this.$vnode.parent && this.$vnode.parent.componentInstance && this.$vnode.parent.componentInstance.cache) {
          if (this.$vnode.componentOptions) {
            var key = this.$vnode.key == null
              ? this.$vnode.componentOptions.Ctor.cid + (this.$vnode.componentOptions.tag ? `::${this.$vnode.componentOptions.tag}` : '')
              : this.$vnode.key;
            var cache = this.$vnode.parent.componentInstance.cache;
            var keys = this.$vnode.parent.componentInstance.keys;
            if (cache[key]) {
              if (keys.length) {
                var index = keys.indexOf(key);
                if (index > -1) {
                  keys.splice(index, 1);
                }
              }
              delete cache[key];
            }
          }
        }
      }
    },

    saveDataBackInfo(url, params, callback, backUrl) {
      let form = this.$refs['form']
      form.validate(valid => {
        // 验证方法
        if (valid) {
          this.loading = true
          // $api.busiContentDesigner.addData
          this.$fetchData(url, params, 'post')
            .then(res => {
              this.loading = false
              if (res) {
                console.log(callback)
                if (callback && typeof callback === 'function') {
                  callback(res)
                }
                this.$message.success('添加成功')
                this.$router.push({path: backUrl})
                // this.$router.go(-1)
              }
            })
            .catch(error => {
              this.loading = false
            })
        } else {
          return false
        }
      })
    },
    updateDataBackInfo(url, params, backUrl) {
      let form = this.$refs['form']
      form.validate(valid => {
        // 验证方法
        if (valid) {
          this.loading = true
          this.$fetchData(url, params, 'post')
            .then(res => {
              this.loading = false
              if (res) {
                this.$message.success('修改成功')
                this.$router.push({path: backUrl})
                // this.$router.go(-1)
              }
            })
            .catch(error => {
              this.loading = false
            })
        } else {
          return false
        }
      })
    },
    scrollToError(){
      let isError = document.getElementsByClassName('is-error')
      isError[0].scrollIntoView({
          // 滚动到指定节点
          block: 'center',
          // 值有auto、instant,smooth，缓动动画（当前是慢速的）
          behavior: 'smooth',
      })
  }
  }
}
